


























import { Component, Vue, Prop } from 'vue-property-decorator';
import { Image as VanImage } from 'vant';
import { MaterialType } from '@/common/consts';
import { MeansItem } from './types';

@Component({
  components: {
    VanImage,
  },
})
export default class MainC extends Vue {
  @Prop() content!: Array<MeansItem>;

  materialType: any = MaterialType

  get leafKey(): String {
    const { leafKey } = this.$route.query;
    return String(leafKey || '');
  }

  get contentList() {
    return this.content.sort((item1, item2) => Number(item1.rank) - Number(item2.rank));
  }

  get operatorSource(): String { // 区分销售和客户预览，若是销售预览，则不触发跳转魔方页面
    const { operatorSource } = this.$route.query;
    return String(operatorSource || '');
  }

  tojumpUrl(material: any) {
    // 判断该jumpUrl是否为魔方，若为魔方需要拼接leafKey参数
    // http://cube.hfe.test.meituan.com/cube/block/test/b13035c7f6ed/3533/index.html?fromOpportunity=true&leafKey=${this.meansReport.leafKey}
    let jumpUrl = material.wisdomMaterialDTO.jumpUrl;
    jumpUrl = jumpUrl.indexOf('cube') > -1 ? `${jumpUrl}&leafKey=${this.leafKey}` : jumpUrl;
    if (jumpUrl && (jumpUrl.indexOf('cube') === -1 || (jumpUrl.indexOf('cube') > -1 && this.operatorSource !== 'BD'))) {
      window.location.href = jumpUrl;
    }
  }
}
